import Api2Talk from './api2talk';

// REGRA: tudo de MENSAGERIA fica na API do 2TALK — por isso Api2Talk (e nao Api do 2DO).
// Api2Talk ja inclui o /api na baseURL, entao a rota vai sem prefixo.
const BASE = 'provider-group';

// Os clients axios sao criados de forma ASSINCRONA (comecam como {} / null ate a baseURL
// resolver). Chamar .get() antes disso — ou com a API fora — derrubava a tela com
// "Cannot read properties of null (reading 'get')". Este guard degrada pra erro tratavel.
const client = () => (Api2Talk && typeof Api2Talk.get === 'function' ? Api2Talk : null);
const apiUnavailable = () => Promise.reject(new Error('API_UNAVAILABLE'));

// A API .NET serializa TUDO minusculo sem separador -> normaliza pra camelCase.
// Usa ?? (nao ||) pros campos que podem ser 0/false/"".
export const normalizeGroup = (g) => ({
  ...g,
  chatId: g.chatid ?? g.chatId,
  groupName: g.groupname ?? g.groupName,
  groupDescription: g.groupdescription ?? g.groupDescription,
  groupId: g.groupid ?? g.groupId,
  inviteLink: g.invitelink ?? g.inviteLink,
  joinApprovalMode: g.joinapprovalmode ?? g.joinApprovalMode,
  totalParticipantCount: g.totalparticipantcount ?? g.totalParticipantCount,
  isSuspended: g.issuspended ?? g.isSuspended ?? false,
  createdAt: g.createdat ?? g.createdAt,
  // 1=pending, 2=confirmed, 3=failed, null=sem operacao
  operationStatus: g.operationstatus ?? g.operationStatus ?? null,
  requestId: g.requestid ?? g.requestId,
  errorCode: g.errorcode ?? g.errorCode,
  errorMessage: g.errormessage ?? g.errorMessage,
  agentCount: g.agentcount ?? g.agentCount ?? 0,
  agentUserIds: g.agentuserids ?? g.agentUserIds ?? [],
});

export const normalizeAgent = (a) => ({
  ...a,
  id: a.id,
  name: a.name,
  email: a.email,
});

export const normalizeProvider = (p) => ({
  ...p,
  id: p.id,
  name: p.name,
});

export const normalizeChannel = (c) => ({
  ...c,
  id: c.id,
  name: c.name,
});

export const normalizeNumber = (n) => ({
  ...n,
  id: n.id,
  phoneNumber: n.phonenumber ?? n.phoneNumber,
  phoneNumberId: n.phonenumberid ?? n.phoneNumberId,
  accountName: n.accountname ?? n.accountName,
});

// Lista os grupos do hirer com o status da ultima operacao de CREATE.
export const getGroups = () => {
  const c = client();
  return c ? c.get(BASE) : apiUnavailable();
};

// Cria o grupo (assincrono): retorna { chatid, providergroupoperationid, status: "pending" }.
export const createGroup = (payload) => {
  const c = client();
  return c ? c.post(BASE, payload) : apiUnavailable();
};

// Edita o grupo. Nome/descricao sincronizam com a Meta se ja confirmado.
export const updateGroup = (chatId, payload) => {
  const c = client();
  return c ? c.put(`${BASE}/${chatId}`, payload) : apiUnavailable();
};

// Reenvia a criacao pro provedor (retry). Bloqueado no backend se ja confirmado.
export const retryGroup = (chatId) => {
  const c = client();
  return c ? c.post(`${BASE}/${chatId}/retry`, {}) : apiUnavailable();
};

// Invite link atual (leitura local). Reset do invite link (op sincrona na Meta, sem webhook).
export const getInviteLink = (chatId) => {
  const c = client();
  return c ? c.get(`${BASE}/${chatId}/invite`) : apiUnavailable();
};
export const resetInviteLink = (chatId) => {
  const c = client();
  return c ? c.post(`${BASE}/${chatId}/invite/reset`, {}) : apiUnavailable();
};

// Rastro do fluxo (tb_integration_event_trace) — modal de erro.
export const getTrace = (chatId) => {
  const c = client();
  return c ? c.get(`${BASE}/${chatId}/trace`) : apiUnavailable();
};

export const normalizeTrace = (t) => ({
  ...t,
  createdAt: t.createdat ?? t.createdAt,
  handlerName: t.handlername ?? t.handlerName,
  status: t.status,
  durationMs: t.durationms ?? t.durationMs,
  errorMessage: t.errormessage ?? t.errorMessage,
  correlationId: t.correlationid ?? t.correlationId,
});

// Agentes elegiveis (tecnicos, nao-somente-cliente). Vem do 2TALK, ja filtrado no backend.
export const getAgents = () => {
  const c = client();
  return c ? c.get(`${BASE}/agents`) : apiUnavailable();
};

// Cascata do form (generica): provedor -> canais do provedor -> numeros ATIVOS do canal.
export const getProviders = () => {
  const c = client();
  return c ? c.get(`${BASE}/providers`) : apiUnavailable();
};

export const getChannelsByProvider = (messageProviderId) => {
  const c = client();
  return c ? c.get(`${BASE}/providers/${messageProviderId}/channels`) : apiUnavailable();
};

export const getChannelNumbers = (channelId) => {
  const c = client();
  return c ? c.get(`${BASE}/channels/${channelId}/numbers`) : apiUnavailable();
};

const ProviderGroupService = {
  getGroups, createGroup, updateGroup, retryGroup, getInviteLink, resetInviteLink, getTrace, getAgents, getProviders, getChannelsByProvider, getChannelNumbers,
  normalizeGroup, normalizeAgent, normalizeProvider, normalizeChannel, normalizeNumber, normalizeTrace,
};
export default ProviderGroupService;
